export default "__VITE_ASSET__CTeulYVG__"